import { ConversationEventModel } from "../schema/conversation-event.model"
import { MongoBaseContainer } from "./mongo-base-container.model"

export class ConversationEventContainer extends MongoBaseContainer{
    conversation_event: ConversationEventModel
}